module.exports = __webpack_public_path__ + "032eb679a327d4668d7537c32c314fbc.svg";